import React, { FC, useCallback, useMemo, useState } from 'react';
import { getEntityById, getLabelFromArrayOfKeys } from '../../utils/DataAccessUtils';
import { patchUpdateACCAuditForMissingAsset } from '../../thunks/acc_audits_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Dropdown, Menu, message, Spin } from 'antd';
import {
	ACC_AUDIT_MATCH_STATUSES,
	MISSING_ASSET_VALUE_WITH_LABEL,
} from '../../utils/AssetCycleUtils';
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import ACCAuditTransferModal from './ACCAuditTransferModal';

const ACCAuditMissingAssetAction: FC<any> = ({
	accAudit,
	cycleRun,
	updateMissingAssetAction,
}): React.ReactElement => {
	const [updating, setUpdating] = useState(null);
	const [transferModalVisible, setTransferModalVisible] = useState(false);

	const changeMissingAssetAction = useCallback(
		(missingAssetAction) => () => {
			if (missingAssetAction === 'transfer') {
				setTransferModalVisible(true);
			} else {
				setUpdating(true);
				updateMissingAssetAction(accAudit.assetCycleCountRunId, accAudit.assetId, {
					missingAssetAction,
				})
					.catch(message.error)
					.finally(() => setUpdating(false));
			}
		},
		[accAudit, updateMissingAssetAction]
	);

	const _hideTransferModal = () => setTransferModalVisible(false);

	const missingAssetActionMenu = useMemo(
		() => (
			<Menu selectedKeys={[accAudit.missingAssetAction]}>
				{MISSING_ASSET_VALUE_WITH_LABEL.map((menu) => (
					<Menu.Item key={menu.key} onClick={changeMissingAssetAction(menu.key)}>
						{menu.label}
					</Menu.Item>
				))}
			</Menu>
		),
		[accAudit, changeMissingAssetAction]
	);

	return accAudit.matchStatus === ACC_AUDIT_MATCH_STATUSES.Missing ? (
		<>
			<Dropdown overlay={missingAssetActionMenu}>
				<div className="flex flex-row items-center gap-2 text-[#FF2D2D]">
					<span>
						{getLabelFromArrayOfKeys(
							MISSING_ASSET_VALUE_WITH_LABEL,
							accAudit.missingAssetAction,
							'key',
							'label'
						) || '--'}
					</span>
					<div>
						<DownOutlined />
					</div>
					{updating ? (
						<div className="ml-2">
							<Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} />
						</div>
					) : null}
				</div>
			</Dropdown>
			{transferModalVisible ? (
				<ACCAuditTransferModal
					accAudit={accAudit}
					accRun={cycleRun}
					onCancel={_hideTransferModal}
					onSuccess={_hideTransferModal}
				/>
			) : null}
		</>
	) : null;
};

const mapStateToProps = (state, ownProps) => ({
	cycleRun: getEntityById(ownProps.match.params.id, state.cycle_runs),
});

const mapDispatchToProps = (dispatch) => ({
	updateMissingAssetAction: (accRunId, assetId, entity) =>
		dispatch(patchUpdateACCAuditForMissingAsset(ROLE_TYPES.BUYER)(accRunId, assetId, entity)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ACCAuditMissingAssetAction as any)
);
